import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Tooltip } from 'ant-design-vue';
import { tooltipProps } from 'ant-design-vue/es/tooltip/Tooltip';


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  props: {
  ...tooltipProps(),
  containerId: {
    type: String,
  }
},
  setup(__props) {

const props = __props;

const getPopupContainer = function (triggerNode: HTMLElement) {
  const targetContainer = document.getElementById("render-control-panel")
  if (targetContainer) {
    return targetContainer
  } else {
    return document.body
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tooltip), _mergeProps({ ...props }, { getPopupContainer: getPopupContainer }), _createSlots({
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    _renderList(_ctx.$slots, (slot, name) => {
      return {
        name: name,
        fn: _withCtx((slotData) => [
          slot
            ? _renderSlot(_ctx.$slots, name, _normalizeProps(_mergeProps({ key: 0 }, slotData)))
            : _createCommentVNode("", true)
        ])
      }
    })
  ]), 1040))
}
}

})